<div class="ap-margin-bottom-2 ap-display-block">
    <ap-accordion size="medium">
        <ap-accordion-item id="summary" [accordionItemTitle]="getItemTitle()">
            <dl>
                <dt>{{ 'shared.amount.label' | apContent }}</dt>
                <dd>
                    <ap-amount-display [value]="betaalverzoek.bedrag.bedrag"></ap-amount-display>
                </dd>

                <dt>{{ 'shared.nameAndIban.label' | apContent }}</dt>
                <dd>
                    {{
                        'shared.nameAndIban.value'
                            | apContent
                                : {
                                      ontvanger: this.getWeergavenaam(this.betaalverzoek.crediteur)
                                  }
                    }}
                    {{ betaalverzoek.crediteur.iban | apIban }}
                </dd>

                <dt>{{ 'shared.description.label' | apContent }}</dt>
                <dd>{{ betaalverzoek.omschrijving }}</dd>

                @if (betaalverzoek.verloopt_op) {
                    <dt>{{ 'shared.expires.label' | apContent }}</dt>
                }
                @if (betaalverzoek.verloopt_op) {
                    <dd>
                        {{
                            'shared.expires.value'
                                | apContent
                                    : {
                                          datum: betaalverzoek.verloopt_op | date: 'dd-MM-yyyy',
                                          tijdstip: betaalverzoek.verloopt_op | date: 'HH:mm'
                                      }
                        }}
                    </dd>
                }
            </dl>
        </ap-accordion-item>
    </ap-accordion>
</div>
